import React from 'react';
import { BaseDashboardActionItem, BaseDashboardActionItemProps } from './BaseDashboardActionItem.component';
import { Button } from '../../../Button';
import { Link } from 'react-router-dom';


export type LinkDashboardActionItemProps = Omit<BaseDashboardActionItemProps, 'action'> & {
  link: string;
  actionText: React.ReactNode;
  onClick?: () => void;
};

/**
 * Specifically meant for action items where the action button is meant to be a link
 */
export const LinkDashboardActionItem: React.VFC<LinkDashboardActionItemProps> = ({ link, actionText, ...props }) => {
  return (
    <BaseDashboardActionItem
      {...props}
      actionButton={(
        <Button
          variant="contained"
          color="secondary"
          component={Link}
          to={link}
          fullWidth
          onClick={props.onClick}
        >
          {actionText}
        </Button>
      )}
    />
  );
};
